<template>
  <div>
    <video controls class="videoBox">
      <source :src="url" />
    </video>
  </div>
</template>

<script>
export default {
  name: 'VideoOpen',
  data() {
    return {
      url: this.$route.query.videoUrl
    };
  }
};
</script>

<style scoped>
.videoBox {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #000;
}
</style>
